<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">Videos</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            v-on:click="$emit('update:show', false)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
              />
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div>
            <!-- A failed upload used to leave the spinner turning with no
                 explanation anywhere on screen. -->
            <div class="upload-error" v-if="uploadError">
              {{ uploadError }}
            </div>
            <div class="row">
              <div class="col-3 text-start">
                <button
                  class="btn w-100 d-block"
                  v-on:click="uploadMenu = true"
                  :class="{
                    'btn-primary': uploadMenu,
                    'btn-simple': !uploadMenu,
                  }"
                >
                  Upload file
                </button>
                <button
                  class="btn w-100 d-block"
                  v-on:click="uploadMenu = false"
                  :class="{
                    'btn-primary': !uploadMenu,
                    'btn-simple': uploadMenu,
                  }"
                >
                  Browse gallery
                </button>
              </div>
              <div class="col" v-if="uploadMenu">
                <file-pond
                  name="video"
                  ref="pond"
                  label-idle="Drop files here..."
                  v-bind:allow-multiple="true"
                  accepted-file-types="video/mp4, video/avi, video/ogg, video/webm, video/quicktime, video/x-quicktime, video/x-msvideo"
                  v-bind:files="myFiles"
                  :server="server"
                  :chunkUploads="true"
                  :chunkForce="true"
                  :chunkSize="1000000"
                  :credits="false"
                />
              </div>
              <div class="col" v-else>
                <div class="row">
                  <div
                    class="col-3 my-2 img-uploader-thumbnail"
                    v-for="video in videos"
                    :key="video.id"
                    v-on:click="selectVideo(video)"
                  >
                    <img
                      class="img-thumbnail"
                      :src="mediaUrl + '/' + video.path + '/frame1.jpg'"
                      :alt="video.name"
                      v-on:error="onPosterError($event)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="text-end mt-4">
              <button class="btn btn-primary" v-on:click="save">Select</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";

import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import http from "../../modules/http";
import { recordProblem } from "../../modules/problem-log";
import tenant from "../../modules/tenant";
const bootstrap = require("bootstrap");

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  name: "VideoUpload",
  props: {
    show: Boolean,
    value: null,
  },
  computed: {
    mediaUrl() {
      return tenant.getAppMediaUrl().replace("/images", "/videos");
    },
  },
  data: function () {
    return {
      myModal: null,
      uploadMenu: true,
      // Shown in the dialog: an upload that fails has to say so on screen,
      // not only in the log.
      uploadError: "",
      myFiles: [],
      videos: [],
      server: {
        process: this.upload,
        revert: process.env.VUE_APP_MEDIA_API + "/videos/revert",
        restore: process.env.VUE_APP_MEDIA_API + "/videos/restore",
        load: process.env.VUE_APP_MEDIA_API + "/videos/load",
        fetch: process.env.VUE_APP_MEDIA_API + "/videos/upload/a",
      },
    };
  },
  watch: {
    show() {
      if (this.myModal === null) {
        this.myModal = new bootstrap.Modal(this.$refs.modal, {
          backdrop: "static",
        });
      }
      if (this.show) {
        if (this.videos.length < 1) {
          http
            .fetch("/videos")
            .then((data) => {
              this.videos = data;
            })
            .catch((err) => {
              this.uploadError =
                "The video library could not be loaded. Try reopening this window.";
              recordProblem(
                "editor",
                "Video library could not be loaded",
                err?.message ?? String(err)
              );
            });
        }
        this.myModal.show();
      } else {
        this.myModal.hide();
      }
    },
  },
  methods: {
    selectVideo(video) {
      let obj = Object.assign({}, video);
      obj.path = this.mediaUrl + "/" + obj.path;
      this.$emit("select", obj);
    },
    upload(
      fieldName,
      file,
      metadata,
      load,
      error,
      progress,
      abort,
      transfer,
      options
    ) {
      const _this = this;
      const request = new XMLHttpRequest();

      const id = Math.round(new Date() / 1000);
      let send = { type: "cover", id: id, videos: [file.name] };

      // Without the catch below a refused upload left FilePond's spinner
      // turning for ever: the error callback was never called, so the dialog
      // said "uploading" and nothing else ever happened. The picture upload
      // beside this one was fixed the same way.
      http
        .fetch("/files/upload", send)
        .then((data) => {
          const formData = new FormData();
          formData.append("token", data.token);
          formData.append("album", id);
          formData.append("category", "cover");

          request.open(
            "POST",
            process.env.VUE_APP_MEDIA_API + "/videos/upload"
          );

          request.setRequestHeader("Upload-Length", file.size);
          request.setRequestHeader(
            "Upload-Name",
            encodeURIComponent(file.name)
          );

          request.upload.onprogress = (e) => {
            progress(e.lengthComputable, e.loaded, file.size);
          };

          request.onload = function () {
            if (request.status >= 200 && request.status < 300) {
              transfer(request.responseText);

              _this.chunkUpload(
                0,
                file,
                options,
                fieldName,
                data,
                progress,
                error,
                load,
                request.responseText
              );
            } else {
              error("oh no");
            }
          };

          request.onerror = function () {
            _this.uploadError = "The upload failed. Check your connection.";
            recordProblem("editor", "Video upload failed (network)", file.name);
            error("network");
          };

          request.send(formData);
        })
        .catch((err) => {
          const detail = err?.message ?? String(err);
          _this.uploadError = `The server refused the video (${detail}).`;
          recordProblem(
            "editor",
            "Video upload refused",
            `${file.name}: ${detail}`
          );
          error(detail);
        });

      return {
        abort: () => {
          request.abort();
          abort();
        },
      };
    },
    chunkUpload(
      start,
      file,
      options,
      fieldName,
      data,
      progress,
      error,
      load,
      fileId,
      i = 0
    ) {
      let _this = this;
      if (start < file.size) {
        let chunkEnd = Math.min(start + options.chunkSize, file.size);
        let chunkSize = chunkEnd - start;
        const chunk = file.slice(start, chunkEnd);

        const chunkForm = new FormData();
        chunkForm.append(fieldName, chunk, file.name);
        chunkForm.append("token", data.token);
        chunkForm.append("album", data.album);
        chunkForm.append("category", "cover");
        chunkForm.append("_method", "PATCH");

        const request = new XMLHttpRequest();

        request.open(
          "POST",
          process.env.VUE_APP_MEDIA_API + "/videos/upload/" + fileId
        );

        request.setRequestHeader("Upload-Offset", start);
        request.setRequestHeader("Upload-Length", chunkSize);
        request.setRequestHeader("Upload-Name", encodeURIComponent(file.name));

        request.upload.onprogress = (e) => {
          progress(e.lengthComputable, start + e.loaded, file.size);
        };

        request.onload = function () {
          if (request.status >= 200 && request.status < 300) {
            _this.chunkUpload(
              chunkEnd,
              file,
              options,
              fieldName,
              data,
              progress,
              error,
              load,
              fileId
            );
          } else {
            if (i >= options.chunkRetryDelays.length) {
              error("oh no");
            } else {
              setTimeout(() => {
                _this.chunkUpload(
                  start,
                  file,
                  options,
                  fieldName,
                  data,
                  progress,
                  error,
                  load,
                  fileId,
                  i + 1
                );
              }, options.chunkRetryDelays[i]);
            }
          }
        };

        // A dropped connection mid-chunk used to end the upload in silence:
        // no error, no completion, the progress bar simply stopped.
        request.onerror = function () {
          recordProblem(
            "editor",
            "Video upload broke off",
            `${file.name} at ${start} bytes`
          );
          error("network");
        };

        request.send(chunkForm);
      } else {
        load();
        _this.uploaded(file.name);
      }
    },
    uploaded() {
      http
        .fetch("/videos")
        .then((data) => {
          this.videos = data;
          this.selectVideo(data[data.length - 1]);
        })
        .catch((err) => {
          // The file is on the media server at this point; only the list
          // failed. Say so, rather than looking like the upload was lost.
          this.uploadError =
            "The video was uploaded, but the list could not be refreshed. Reopen this window.";
          recordProblem(
            "editor",
            "Video list refresh failed after upload",
            err?.message ?? String(err)
          );
        });
    },
    onPosterError(e) {
      e.target.src = "/loading.gif";
    },
    save() {
      this.$emit("update:show", false);
    },
  },
  emits: ["update:show", "update:value"],
  components: { FilePond },
};
</script>

<style scoped>
.upload-error {
  background: #fee2e2;
  color: #991b1b;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 12.5px;
  margin-bottom: 10px;
}
</style>
